import moment from "moment";
import { countries } from "country-data";

export function alpha2ToCountryName(code) {
  if (!code) return "";
  const c = countries[code.toUpperCase()];
  return c?.name || "";
}

export function templateTransitVisaData(data) {
  return [
    {
      elements: [
        {
          type: "title",
          value: "Origin",
        },
        {
          type: "text",
          value: alpha2ToCountryName(data?.originCountry),
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Destination",
        },
        {
          type: "text",
          value: alpha2ToCountryName(data?.destinationCountry),
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Transit",
        },
        {
          type: "text",
          value: data?.transitCountry
            ? alpha2ToCountryName(data?.transitCountry)
            : "---",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Transit Visa Required",
        },
        {
          type: "text",
          value: data?.requiresTransitVisa ? "Required" : "Not Required",
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Additional Notes",
        },
        {
          type: "text",
          value: data?.notes
            ? data.notes.length > 80
              ? data.notes.slice(0, 80) + "…"
              : data.notes
            : "------",
        },
      ],
      value: "",
      width: "md:w-[25%]",
    },

    {
      elements: [{ type: "activeStatus", value: data?.isActive }],
      width: "md:w-[10%]",
    },
    {
      elements: [
        // { type: "title", value: "Registered at" },
        { type: "text", value: moment(data?.createdAt).format("YYYY/MM/DD") },
        { type: "title", value: moment(data?.createdAt).format("hh:mm A") },
      ],
      width: "md:w-[10%]",
    },
  ];
}
